import { createAction } from 'redux-actions';

import {
  LOAD_DOCUMENT_LIST,
  LOAD_DOCUMENT_LIST_SUCCESS,
  LOAD_DOCUMENT_LIST_ERROR,
  RESET_DOCUMENT_LIST,
} from './type';

//Load list position
export const loadDocumentListAction = createAction(LOAD_DOCUMENT_LIST);
export const loadDocumentListSuccessAction = createAction(
  LOAD_DOCUMENT_LIST_SUCCESS,
);
export const loadDocumentListErrorAction = createAction(
  LOAD_DOCUMENT_LIST_ERROR,
);

export const resetDocumentListAction = createAction(RESET_DOCUMENT_LIST);
